import React, { Fragment } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Chip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog';
import { DisplayWeblinkPreviewDialog } from '../../components/DisplayWeblinkPreviewDialog';
import { AppConfig } from '../../AppConfig';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { ExpressionDialog } from '../../components/ExpressionDialog';
import { assetsFormAddition, mediaStateOptions } from '../../data/data';
import { SearchBar } from '../../common/components/SearchBar';
import { BulkUploadMediaDialog } from '../../components/BulkUploadMediaDialog';
import { MultiselectFilterBar } from '../../common/components/MultiselectFilterBar';

export class AssetsItems extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'AssetsItems'
    this.pageTitle = Helper.getString('media')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.noTableHead = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('media') },
    ]
    this.defaultState = 'LIVE'
    this.assetTagsFieldKey = (this.options && this.options.pageForOrgType === 'PARTNER') ? 'tagsPartner' : 'tagsBo'

    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'assets'], queryParams: { orgId: this.orgId, pb: 'fieldDef', state: this.defaultState, limit: 100 } },
      { method: 'GET', paths: ['devicecfs'], queryParams: { groupId: this.orgId, pb: 'fieldDefCfSuggestions' } },
      { method: 'GET', paths: ['items'], queryParams: { groupId: 'assettag' + this.orgId, pb: 'fieldDef', limit: 1000 } }
    ]
    if (this.options && this.options.pageForOrgType === 'PARTNER') {
      this.toFetch.push({ method: 'GET', paths: ['orgs', this.orgId] })
    }
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      // Order: (current) => current.order,
      Image: (current) => {
        if (current.iType === 'VIDEO') {
          return AppUiHelper.renderVideoThumbnailCustomStyle(current, {}, { _IMAGEFIT: false })
        } else if (current.iType === 'WEBLINK') {
          return (<i className={'material-icons-outlined ' + css(Styles.icons)}>http</i>)
        } else if (current.iType === 'TEXT') {
          return (<i alt={Helper.getString('assetTextAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >text_snippet</i>)
        } else {
          return AppUiHelper.itemImage(
            { ...current, _IMAGEFIT: false, image: (current.iType === 'IMAGE' || current.iType === 'QRWEBLINK') ? current.content : undefined })
        }
      },
      Info: (current) => {
        const currentTags = current[this.assetTagsFieldKey] || []
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.title}</span>
            <br />
            <span className={css(Styles.spanValue)}>{current.iType} | {current.durationSecs} Secs</span>
            {currentTags.length > 0 &&
              <div className={css(Styles.tagHolder)}>
                {AppHelper.getTagChips(currentTags, this.state.tags).map((x, i) =>
                  <Chip key={'chip_' + i} label={x} size='small' className={css(Styles.tagChip)} />
                )}
              </div>
            }
          </div>
        )
      },
      Status: (current) => {
        return AppUiHelper.itemStatusContainer(current)
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.addNewLabel = Helper.getString('addNewMedia')
    this.actionData = {}
    this.allowAccessToRoles = ['CAMPAIGNS']
    this.noAdd = true
    this.videoUploadValidations = {}
  }

  _changePaginationLimit() {
    if(this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 100
  }

  _filterRowItems(items) {
    if (items && this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') {
      items = items.filter(item => item.iType !== 'HDMI-IN' && item.iType !== 'ACCUWEATHER' && item.iType !== 'TEXT')
    }
    return items
  }

  onFetchSuccess(results, opts) {
    // Pagination -- Start
    const { fetchNext } = opts || {}
    if(results[0]) this.handleNextpage(results[0])
    this._changePaginationLimit()
    if (fetchNext) {
      const newRowItems = this._filterRowItems(results[0].items)
      const updatedItems = this.state.items.concat(Helper.dictToArray(newRowItems))
      this.setState({
        items: updatedItems,
        nextPageState: ApiHelper.State.READY,
      })
      return
    }
    // Pagination -- ENDS
    if (this.options && this.options.pageForOrgType === 'PARTNER') this.org = results[3]
    this.formDefinition = results[0].fieldDef;
    // For Partner removed Accuwether and HDMI-IN
    if (this.options.pageForOrgType === 'PARTNER') {
      this.formDefinition.steps[0].fields.find(i => i.key === 'iType').options = this.formDefinition.steps[0].fields.find(i => i.key === 'iType').options.filter(x => x.key !== 'HDMI-IN' && x.key !== 'ACCUWEATHER' && x.key !== 'TEXT')
    }
    const options = {
      fieldKey: 'state',
      keyToReplace: 'LIVE',
      replaceWithValue: 'ENABLED',
    }
    this.formDefinition = AppHelper.changeFieldOptionLabel(this.formDefinition, options)
    // Push New dateTimeStr Fields
    UiHelper.populateOptions(this.formDefinition, results[2], 'tagsBo')
    UiHelper.populateOptions(this.formDefinition, results[2], 'tagsPartner')
    this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(x => {
      if (x.type === 'check_box' && (x.key === 'tagsBo' || x.key === 'tagsPartner')) {
        x.addOptions = true
      }
      return x.key === this.assetTagsFieldKey || (x.key !== 'tagsBo' && x.key !== 'tagsPartner')
    })
    AppHelper.addScheduleFieldsToAssetsFormField(assetsFormAddition, this.formDefinition)
    // if (assetsFormAddition &&
    //     this.formDefinition &&
    //     this.formDefinition.steps &&
    //     this.formDefinition.steps[0] &&
    //     this.formDefinition.steps[0].fields) {
    //   // this.formDefinition.steps[0].fields.push(...assetsFormAddition)
    //   if (this.formDefinition.steps[0].fields.length > 0) {
    //     this.formDefinition.steps[0].fields.splice(this.formDefinition.steps[0].fields.length - 1, 0, ...assetsFormAddition);
    //     this.formDefinition.steps[0].fields[this.formDefinition.steps[0].fields.length - 1].placement = 'left'
    //     this.formDefinition.steps[0].fields[this.formDefinition.steps[0].fields.length - 4].placement = 'right'
    //   } else {
    //     this.formDefinition.steps[0].fields.push(...assetsFormAddition);
    //   }
    //   console.log('thisFields',this.formDefinition.steps[0].fields)
    // }
    // TODO: This is test fields added for development purpose only, This field needs to come from API only.
    // -- START --
    this.formDefinition.steps[0].fields.map((x) => {
      if (x.condition && x.condition.value === 'IMAGE') {
        x.autoFillTitleKey = 'title'
      }
      if (x.condition && x.condition.value === 'VIDEO' && x.documentUpload) {
        x.autoFillField = 'durationSecs' // add generic
        x.autoFillVideoDuration = true
        x.autoFillTitleKey = 'title'
        x.maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
        x.maxWidthOrHeight = 1920
        x.fileSizeLimit = AppHelper.getMaxVideoFileSize(this.options, this.org)
        if ((this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') && this.org && AppHelper.hasFeature(this.org, 'LARGEVIDEO')) {
          x.maxWidthOrHeight = 4096 // 4k max res
        }
        // eslint-disable-next-line camelcase
        this.formDefinition.steps[0].fields.find(i => i.key === x.autoFillField).v_condition = { key: 'iType', value: 'VIDEO', type: 'disable' }
        // Change in label for video START ----
        this.videoUploadValidations = {
          maxWidthOrHeight: x.maxWidthOrHeight,
          maxVideoDuration: x.maxVideoDuration,
          fileSizeLimit: x.fileSizeLimit
        }
        AppHelper.attachVideoValidationLabel({
          formDefinition: this.formDefinition,
          ...this.videoUploadValidations
        })
        // END ----
      }
      if(x.key === 'startStr' || x.key === 'endStr') {
        x.disablePast = true
      }
      return x
    })
    // -- End --
    if (AppConfig.FEATURES_OFF.includes('ASSET_WEBLINK')) {
      this.formDefinition.steps[0].fields.find(i => i.key === 'iType').options = this.formDefinition.steps[0].fields.find(i => i.key === 'iType').options.filter(x => x.key !== 'WEBLINK')
    }
    const mediaItems = this._filterRowItems(results[0].items)
    const items = results[0] ? Helper.dictToArray(mediaItems) : []
    this.setState({
      items: items,
      previewExpression: false,
      customFields: results[1].items,
      tags: results[2],
      stateFilterValue: this.defaultState,
      showBulkUploadModal: false
    })
    if (UiHelper.isUserHasRoles(this.allowAccessToRoles)) {
      this.headerActions = [
        {
          icon: 'upload',
          label: Helper.getString('bulkUpload'),
          tooltip: Helper.getString('bulkUpload'),
          type: 'icon-mobile',
          onClick: () => this.setState({ showBulkUploadModal: true })
        },
        {
          icon: 'add',
          label: Helper.getString('addNewMedia'),
          tooltip: Helper.getString('addNewMedia'),
          type: 'icon-mobile',
          onClick: () => this.openModalForAdd()
        }
      ]
    } else {
      this.headerActions = []
    }
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = false
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['assets']),
      apiData: { orgId: this.orgId },
    });
  }

  // onDelete(current) {
  //   this.setState({
  //     apiMethod: 'DELETE',
  //     apiEndPoint: ApiHelper.makeUrlPath(['assets', current.id]),
  //   });
  // }

  onEdit(current) {
    this.actionData = { currentId: current.id }
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['assets', current.id]),
    });
  }

  //SEARCH filter Dependencies start
  getQueryParams() {
    const queryParams = { }

    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if (this.state.selectedTagsId && this.state.selectedTagsId.length > 0) {
      queryParams[this.assetTagsFieldKey] = this.state.selectedTagsId.map(x => x.key).join(',')
    }
    if (this.state.stateFilterValue) {
      queryParams.state = this.state.stateFilterValue
    }
    queryParams.orgId = this.orgId;
    queryParams.pb = 'fieldDef';
    queryParams.limit = 100;
    this.toFetch[0] = { method: 'GET', paths: ['miscs', 'assets'], queryParams}
    console.log(this.toFetch[0])
    return queryParams
  }

  searchHandler() {

    ApiHelper.call(
      {
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'assets'], this.getQueryParams())
      },
      function (err, data) {
        if (err) {
          this.emptyText = Helper.getErrorMsg(err)
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            item: {},
            items: [],
            nextPage: '',
            inProcessSearch: false,
            inProcessTagSearch: false,
            inProcessOnList: false
          })
          return
        } else {
          this.emptyText = (
            <span className={css(Styles.emptyTextHolder)}>
              <span>{Helper.getString('noAssets')}</span>
            </span>
          )
          this.handleNextpage(data)
          this._changePaginationLimit()
          this.setState({
            successMsg: '',
            item: data,
            items: this._filterRowItems(data.items),
            errMsg: null,
            inProcessSearch: false,
            inProcessTagSearch: false,
            inProcessOnList: false
          })
        }
      }.bind(this));
  }

  onList() {
    if (this.searchBarComponent) this.searchBarComponent.setState({ searchText: '' })
    this.setState({ searchText: '', selectedTagsId: [], inProcessOnList: true, stateFilterValue: this.defaultState }, () => this.searchHandler())
  }

  onSearch = (searchText) => {
    this.setState({ searchText: searchText, selectedTagsId: searchText ? [] : (this.state.selectedTagsId || []), inProcessSearch: true }, () => { this.searchHandler() })
  }

  onTagFilter = (selectedTagsId) => {
    this.setState({
      searchText: '',
      selectedTagsId,
      inProcessTagSearch: true
    }, () => this.searchHandler())
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue: selectedState
    })
  }

  async onFormFieldOptionAdd(options) {
    const { formField, value, formId } = options
    if (this.formDefinition && this.formDefinition.formId === formId) {
      await ApiHelper.callAwait({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['items'], { groupId: 'assettag' + this.orgId }),
        jsonBody: { groupId: 'assettag' + this.orgId, title: value }
      })
      const updatedResult = await ApiHelper.callAwait({
        method: 'GET',
        paths: ['items'],
        queryParams: { groupId: 'assettag' + this.orgId, pb: 'fieldDef', limit: 100 }
      })
      this.formDefinition.steps[0].fields.map(x => {
        if (x.key === formField.key) {
          UiHelper.populateOptions(this.formDefinition, updatedResult, formField.key)
        }
        return x
      })
      this.setState({ tags: updatedResult || {} })
      return updatedResult || {}
    }
  }

  renderPreviewDialogs() {
    if (this.state.previewExpression) {
      return (
        <ExpressionDialog
          caller={this}
          current={this.state.current}
          isOpen={this.state.previewExpression || false}
          onClosed={() => { this.setState({ previewExpression: false }) }}
          onCompleteAction={(options) => {
            this.setState({ previewExpression: false })
            this.fetchItems()
          }}
          title={'Condition Expression'}
          customFields={this.state.customFields}
          tags={this.state.tags}
        ></ExpressionDialog>
      )
    }
    if (!this.state.preview || !this.state.current) return '';
    if (this.state.current.iType === 'IMAGE' || this.state.current.iType === 'QRWEBLINK' || this.state.current.iType === 'VIDEO') {
      return (
        <DisplayPreviewDialog
          title={this.state.current.title}
          isOpen={this.state.preview ? true : false}
          adLink={this.state.current.content}
          onClosed={() => this.setState({ preview: undefined })}
        />
      )
    } else if (this.state.current.iType === 'WEBLINK') {
      return (
        <DisplayWeblinkPreviewDialog
          title={this.state.current.title}
          isOpen={this.state.preview ? true : false}
          adLink={this.state.current.contentName}
          onClosed={() => this.setState({ preview: undefined })}
        />
      )
    }
  }

  _handleMultipleFileSave = async (props) => {
    const { uploadedFileList, caller } = props
    // Check is any of the file exist in list
    if (!Array.isArray(uploadedFileList) || !uploadedFileList.length) {
      caller.setState({ errMsg: Helper.getString('noMediaToSave') })
      return
    }
    // Check if any file is still uploading..
    const filesInProgress = (caller.state.files || []).filter(f => f.status === 'uploading')
    if (filesInProgress.length > 0) {
      caller.setState({ errMsg: Helper.getString('fileIsStillUploading') })
      return
    }
    const requests = uploadedFileList.map(uploadedFile => {
      const current = {
        title: AppHelper.getBaseFileName(uploadedFile.file.name),
        iType: AppHelper.getFileType(uploadedFile.file),
        contentName: uploadedFile.signedUploadInfo.fields.key,
        durationSecs: uploadedFile.duration
      }
      const payload = AppHelper.buildPayload(this.formDefinition.steps[0].fields, current)
      payload.orgId = this.orgId
      const apiOptions = {
        method: 'POST',
        paths: ['assets', this.orgId],
        jsonBody: payload
      }
      // Attach file in both .then and .catch
      return ApiHelper.callAwait(apiOptions)
        .then(res => ({ status: 'fulfilled', file: uploadedFile, value: res }))
        .catch(err => ({ status: 'rejected', file: uploadedFile, reason: err }))
    })

    caller.setState({ savingInProgress: true })
    const results = await Promise.all(requests)
    caller.setState({ savingInProgress: false })

    const failed = results.filter(r => r.status === 'rejected')
    const succeeded = results.filter(r => r.status === 'fulfilled')

    if (failed.length === 0) {
      this.setState({ showBulkUploadModal: false })
      console.log('Upload completed')
      this.fetchItems()
    } else {
      console.log(failed)
      const errMsg = `Failed to save ${failed.length} file${failed.length > 1 ? 's' : ''}.`
      caller.setState({ errMsg, unsavedFiles:failed })
      console.log(errMsg)
    }
  }

  renderAboveTable() {
    return(
      <Fragment>
        {
          this.state.showBulkUploadModal &&
          <BulkUploadMediaDialog
            isOpen={this.state.showBulkUploadModal || false}
            title={Helper.getString('bulkUpload')}
            uploadLocation={this.orgId}
            onClosed={() => { this.setState({ showBulkUploadModal: false }) }}
            videoUploadValidation = {this.videoUploadValidations}
            onSave={this._handleMultipleFileSave}
          />
        }
        <div className={css(Styles.searchContainer)}>
          <SearchBar
            ref={(child) => (this.searchBarComponent = child)}
            hint={'Search'}
            inProcessSearch={this.state.inProcessSearch || false}
            inProcessOnList={this.state.inProcessOnList || false}
            onSearch={this.onSearch.bind(this)}
            searchText={this.state.searchText}
            onSinglePickerFilter={this.onStateFilter.bind(this)}
            singleSelectPicker={
              {
                options: mediaStateOptions,
                defaultValue: this.state.stateFilterValue,
              }
            }
            showRecentButtonText={'Reset Filter'} />
          <MultiselectFilterBar
            value={this.state.selectedTagsId || []}
            onList={this.onList.bind(this)}
            onSearch={this.onTagFilter}
            inProcessSearch={this.state.inProcessTagSearch || false}
            inProcessOnList={this.state.inProcessOnList || false}
            items={this.state.tags && this.state.tags.items && this.state.tags.items.map(x => {
              return { key: x.id, title: x.title }
            })}
            placeholder={Helper.getString('selectTags')}
            resetFilterText={'Reset Filter'}
          />
        </div>
        {this.renderPreviewDialogs()}
      </Fragment>
    )
  }

  previewButton(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
          {/* <i className='material-icons-outlined' onClick={() => {this.setState({preview: true, current})}}>visibility</i> */}
        </span>
      </Tooltip>
    )
  }

  expressionButton(current) {
    return (
      <Tooltip title='Condition Expression' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => { this.setState({ previewExpression: true, current }) }}>filter_tilt_shift</i>
        </span>
      </Tooltip>
    )
  }

  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    // actions.push(UiHelper.buttonDelete(this, current))
    if (current.iType === 'IMAGE' || current.iType === 'QRWEBLINK' || current.iType === 'VIDEO' || current.iType === 'WEBLINK') {
      UiHelper.addActionButtonByRole(actions, this.previewButton(current), [])
    }
    // Expression Dialog
    if (this.options && this.options.pageForOrgType === 'PARTNER') {
      UiHelper.addActionButtonByRole(actions, this.expressionButton(current), this.allowAccessToRoles)
    }
    return actions
  }

  selectedImageDimension(props) {
    this.setState({ currentImageDimension: props })
  }

  customSubmit(options) {
    const { formData, caller, formType } = options
    const maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
    if (formData.iType === 'VIDEO' && Math.round(formData.durationSecs) > maxVideoDuration) {
      let errorMessage = Helper.getString('maxDurationVideo')
      errorMessage = errorMessage.replace('%second%',maxVideoDuration)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        message: errorMessage,
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.iType === 'IMAGE' && (formData.durationSecs > 15 || formData.durationSecs < 5) && this.orgId !== 'PRODUCT') {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('maxDurationImage'),
        message: Helper.getString('maxDurationImage'),
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.iType === 'QRWEBLINK' && formData.orientation && this.state.currentImageDimension && this.state.currentImageDimension.width && this.state.currentImageDimension.height) {
      const imageOrientation = this.state.currentImageDimension.width > this.state.currentImageDimension.height ? 'LANDSCAPE' : 'PORTRAIT';
      if (imageOrientation !== formData.orientation.toUpperCase()) {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getString('imageOrientationMismatch'),
          message: Helper.getString('imageOrientationMismatch'),
          success: false,
          inProcess: false
        });
        return;
      }
    }
    // if (formData.order) {
    //   formData.order = AppHelper.padNumberWithZeros(parseInt(formData.order))
    //   if (formData.order.length > 3) {
    //     caller.setState({
    //       fetchState: ApiHelper.State.ERROR,
    //       errMsg: Helper.getString('displayOrderLength'),
    //       message: Helper.getString('displayOrderLength'),
    //       success: false,
    //       inProcess: false
    //     })
    //     return
    //   }
    // }
    let apiOptions = {}
    if (formType === 'edit') {
      apiOptions = {
        method: 'PUT',
        paths: ['assets', this.actionData.currentId],
        jsonBody: { ...formData }
      }
    } else if (formType === 'add') {
      apiOptions = {
        method: 'POST',
        paths: ['assets', this.orgId],
        jsonBody: { ...formData }
      }
    }
    ApiHelper.call(apiOptions, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      } else {
        this.setState({ modalOpen: false })
        this.fetchItems()
        return
      }
    })
  }
}

const Styles = StyleSheet.create({
  actionIconImage: {
    width: 20,
    height: 20
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  icons: {
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  searchContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    gap: 10
  },
  tagHolder: {
    marginTop: 4
  },
  tagChip: {
    marginRight: 4,
    marginTop: 4
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/AssetsItems.js